import { render, staticRenderFns } from "./NewsletterAlt.vue?vue&type=template&id=39275531"
import script from "./NewsletterAlt.vue?vue&type=script&lang=js"
export * from "./NewsletterAlt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports